module.exports = __webpack_public_path__ + "static/media/google-images.82315d36.png";